<script>
  export let additionalAddresses = [];
  export let deleteAddress = () => {};
  export let addAddress = () => {};

  let newAddressOwner;
  let newAddressAddress;
</script>

<div class="col table-responsive-sm" style="height: 400px; overflow: scroll;">
  <label for="newAddress" class="form-label">Adres Bilgileri</label>
  <div class="d-flex flex-row justify-content-center">
    <input
      type="text"
      class="form-control text-center"
      placeholder="Adresin Sahibi"
      bind:value={newAddressOwner}
    />
    <input
      type="text"
      class="form-control text-center"
      placeholder="Adres Bilgisi"
      bind:value={newAddressAddress}
    />
  </div>
  <div class="text-center">
    <button
      on:click|preventDefault={addAddress(
        newAddressOwner + '-' + newAddressAddress
      )}
      class="btn btn-success mt-2">Ekle</button
    >
  </div>
  <table class="table-sm">
    <thead>
      <tr>
        <th class="w-50">Adresin Sahibi</th>
        <th class="w-50">Adres</th>
        <th class="w-25">İşlemler</th>
      </tr>
    </thead>
    <tbody>
      {#each additionalAddresses as address}
        <tr>
          <td class="w-50"
            ><input
              type="text"
              class="form-control"
              required
              bind:value={address.owner}
            />
          </td>
          <td class="w-50"
            ><textarea
              type="text"
              class="form-control"
              style="resize:none;"
              required
              bind:value={address.address}
            /></td
          >
          <td class="w-25">
            <button
              on:click|preventDefault={deleteAddress(address._id)}
              class="btn btn-danger">Sil</button
            ></td
          >
        </tr>
      {/each}
    </tbody>
  </table>
</div>
